module.exports = __webpack_public_path__ + "static/media/HubertMittermayerNesterovskiy.8f5d4015.jpg";